'use client';
import useSWR from 'swr';
import { CollapseContainer, useTranslation } from '@weareconceptstudio/core';
import { getFaqs } from '@/libs/get-data';
import { useMemo, useState } from 'react';

//* Component
import FaqItem from '../Item';
import Button from '@/components/Button';
import SkeletonFaq from '../Skeleton';

const FaqAllItem = () => {
	const { selectedLang } = useTranslation();

	const { data } = useSWR(
		() => (selectedLang ? ['faqs', selectedLang] : null),
		(_, selectedLang) => getFaqs({ selectedLang }),
		{
			revalidateOnFocus: false,
			revalidateOnReconnect: false,
			dedupingInterval: 1000 * 60 * 10,
		}
	);

	//! States
	const [changeDataTitle, setChangeDataTitle] = useState('all');

	const controlData = useMemo(() => {
		//! Filter Data
		const filteredData = changeDataTitle === 'all' ? data : data?.filter((item) => item.name === changeDataTitle);

		return (
			<CollapseContainer clickable>
				<div className='wrapper-all-categories'>
					{filteredData?.map((item) => {
						return (
							<FaqItem
								data={item}
								key={item.name}
							/>
						);
					})}
				</div>
			</CollapseContainer>
		);
	}, [changeDataTitle, data]);

	const navigationWrapper = useMemo(() => {
		//! Select Categories
		const selectCategories = (item) => {
			setChangeDataTitle(item);
		};

		return (
			<>
				<Button
					text={'all'}
					onClick={() => selectCategories('all')}
					className={`category tag ${changeDataTitle === 'all' ? 'active' : ''}`}
				/>

				{data?.map((item) => (
					<Button
						key={item.name}
						onClick={() => selectCategories(item.name)}
						className={`category tag ${item.name === changeDataTitle ? 'active' : ''}`}>
						{item.name}
					</Button>
				))}
			</>
		);
	}, [changeDataTitle, data]);

	return data ? (
		<div className='wrapper-button-categories'>
			<div className='wrapper-button-control'>{navigationWrapper}</div>

			{controlData}
		</div>
	) : (
		<SkeletonFaq />
	);
};

export default FaqAllItem;
